import styled from 'styled-components';
import { Drawer } from 'antd';

const COLORS = {
	MASK: 'rgba(0, 0, 0, 0.2)',
	SHADOW: '#0000001a'
};

export const Container = styled(Drawer)`
	.ant-drawer-mask {
		background: ${COLORS.MASK};
	}

	.ant-drawer-content-wrapper {
		box-shadow: -3px -2px 15px 1px ${COLORS.SHADOW};
		width: 928px !important;
	}

	.ant-drawer-content {
		padding: 0;
	}

	.ant-drawer-header {
		padding: 32px 40px;
		border: none;
		border-bottom: 1px solid ${({ theme }) => theme.palette.secondary['150']};

		.ant-drawer-header-title {
			flex-direction: row-reverse;

			.ant-drawer-close {
				margin: 0;
			}
		}

		.ant-drawer-title {
			font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
			font-weight: ${({ theme }) => theme.sizes.weights.semibold};
			line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
		}
	}

	.ant-drawer-footer {
		padding: 32px;
		text-align: center;
	}

	.ant-drawer-body {
		overflow-y: auto;
		overflow-x: hidden;
		display: flex;
		flex-direction: column;
		padding: 2rem 40px;

		::-webkit-scrollbar {
			width: 4px;
			background: transparent;
		}

		::-webkit-scrollbar-track {
			border-radius: ${({ theme }) => theme.border.border_radius.br_xs};
		}

		::-webkit-scrollbar-thumb {
			background: ${({ theme }) => theme.palette.secondary['150']};
			border-radius: ${({ theme }) => theme.border.border_radius.br_xs};
		}

		::-webkit-scrollbar-thumb:hover {
			background: ${({ theme }) => theme.palette.secondary['300']};
		}
	}

	@media (max-width: 1366px) {
		.ant-drawer-header {
			padding: 1.5rem 1.5rem 0 1.5rem;
		}
	}

	::-webkit-scrollbar {
		width: 4px;
		background: transparent;
	}

	::-webkit-scrollbar-track {
		border-radius: ${({ theme }) => theme.border.border_radius.br_xs};
	}

	::-webkit-scrollbar-thumb {
		background: ${({ theme }) => theme.palette.secondary['150']};
		border-radius: ${({ theme }) => theme.border.border_radius.br_xs};
	}

	::-webkit-scrollbar-thumb:hover {
		background: ${({ theme }) => theme.palette.secondary['300']};
	}

	.ant-radio-wrapper {
		margin-right: 16px;
	}

	.text-normal {
		font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
		font-weight: ${({ theme }) => theme.sizes.weights.regular};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
		text-align: left;
		margin-bottom: 30px;

		&.text-bold {
			font-weight: ${({ theme }) => theme.sizes.weights.semibold};
			text-align: center !important;
		}
	}
`;
